
export default {
  name: "cal-card-section",
  props: ["cards"],
  computed: {
    // TODO refactor this code
    mobileScreen() {
      if (window.innerWidth < 768) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    sendSMS(item) {
      // check device is mobile or web
      if (window.innerWidth < 768) {
        const defaultMessage = encodeURIComponent(this.$t("sms_body"));
        const recipientNumber = encodeURIComponent("+1(888)618-1211");
        const smsUrl = `sms:${recipientNumber}?body=${defaultMessage}`;
        window.location.href = smsUrl;
      } else {
        if (item.button_text !== undefined) {
          this.$router.push(this.localePath(`${item.button_path}`));
        }
      }
    }
  }
};
